/**
 * The strip under a filter's conditions: add one, clear them, keep them.
 *
 * Both boards have a filter — one asking about people, one about segments — and
 * the vocabularies share nothing. This does: adding a condition, clearing them
 * all, and turning what is on screen into a tab are the same three acts
 * whatever the conditions ask about.
 *
 * Clearing and saving appear only once there is something to clear or save. A
 * "Clear" beside an empty filter is a control that does nothing, and a person
 * who presses it learns only that it does nothing.
 */
export function FilterActions({
  count,
  onAdd,
  onClear,
  onSaveAsView,
}: {
  /** How many conditions there are, which decides what is worth offering. */
  readonly count: number
  readonly onAdd: () => void
  readonly onClear: () => void
  readonly onSaveAsView: () => void
}) {
  return (
    <span className="flex flex-wrap items-center gap-2 pt-1">
      <button
        className="font-medium text-[12px] text-brand hover:underline"
        onClick={onAdd}
        type="button"
      >
        + Add a condition
      </button>
      {count === 0 ? null : (
        <>
          <button
            className="font-medium text-[12px] text-t3 hover:text-t1"
            onClick={onClear}
            type="button"
          >
            Clear
          </button>
          <button
            className="ml-auto rounded-pill border border-line px-3 py-1 font-semibold text-[12px] text-t2 hover:text-t1"
            onClick={onSaveAsView}
            type="button"
          >
            Save as a view
          </button>
        </>
      )}
    </span>
  )
}
